import { useEffect, useState } from "react";

export const useIsMobileView = () => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobileView;
};

export const useBreakpointView = (breakpoint: number) => {
  const [isBreakpointView, setIsBreakpointView] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsBreakpointView(window.innerWidth <= breakpoint);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isBreakpointView;
};

export const useScrollToTop = () => {
  const isMobileView = useIsMobileView();
  const scrollToTop = () => {
    const container = isMobileView
      ? document.getElementsByClassName("ant-tabs-content-holder")?.[0]
      : document.getElementById("notes-container");

    container?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return scrollToTop;
};
